import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { BUSINESS, LOGO_URL } from "../../mocks/businessData";

const NAV_LINKS = [
  { label: "Home",      path: "/" },
  { label: "Services",  path: "/services" },
  { label: "About",     path: "/about" },
  { label: "Locations", path: "/location" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen]  = useState(false);
  const location                 = useLocation();

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-stone-950 border-b border-stone-800/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* ── Logo ── */}
        <Link to="/" className="flex items-center gap-3.5 cursor-pointer flex-shrink-0 group">
          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
            <img
              src={LOGO_URL}
              alt="The Drapery & Blind Co."
              className="w-10 h-10 object-contain"
            />
          </div>
          <div className="hidden sm:block">
            <p className="text-[11px] font-bold tracking-[0.28em] uppercase leading-tight text-white">
              The Drapery
            </p>
            <p className="text-[11px] tracking-[0.18em] uppercase leading-tight text-white/50">
              &amp; Blind Co.
            </p>
          </div>
        </Link>

        {/* ── Desktop Nav ── */}
        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`relative text-[11px] tracking-[0.22em] uppercase font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer group ${
                location.pathname === link.path
                  ? "text-amber-400"
                  : "text-white/70 hover:text-white"
              }`}
            >
              {link.label}
              {/* Active underline */}
              {location.pathname === link.path && (
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-amber-400" />
              )}
            </Link>
          ))}
        </nav>

        {/* ── Desktop CTAs ── */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href={BUSINESS.phoneHref}
            className="flex items-center gap-1.5 text-[11px] font-bold tracking-wide text-white/80 hover:text-amber-400 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 inline-flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-fill text-xs" />
            </span>
            {BUSINESS.phone}
          </a>
          <a
            href="#quote-form"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("quote-form")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-luxury bg-amber-700 hover:bg-amber-600 text-white text-[11px] tracking-[0.22em] uppercase font-bold px-5 py-2.5 rounded-sm whitespace-nowrap cursor-pointer transition-all duration-300"
          >
            Free Quote
          </a>
        </div>

        {/* ── Mobile phone + Hamburger ── */}
        <div className="md:hidden flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            className="w-9 h-9 flex items-center justify-center rounded-sm bg-amber-700 text-white cursor-pointer"
            aria-label="Call us"
          >
            <i className="ri-phone-fill text-sm" />
          </a>
          <button
            className="w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl text-white ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </div>
      </div>

      {/* ── Mobile Menu ── */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-5 flex flex-col gap-1">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-[11px] tracking-[0.22em] uppercase font-semibold py-3 border-b border-stone-50 cursor-pointer transition-colors whitespace-nowrap ${
                location.pathname === link.path ? "text-amber-700" : "text-stone-700 hover:text-amber-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="#quote-form"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(false);
              document.getElementById("quote-form")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="mt-3 text-center bg-amber-700 text-white text-[11px] tracking-[0.22em] uppercase font-bold py-3.5 rounded-sm cursor-pointer whitespace-nowrap"
          >
            Request Free Quote
          </a>
        </div>
      )}
    </header>
  );
}
